import { createContext } from 'react'
import { InstantPriceContextContract } from './contracts/InstantPriceContextContract'

export const InstantPriceContext = createContext<InstantPriceContextContract>(
  {} as InstantPriceContextContract
)
